export default __webpack_public_path__ + "b7d95238abaf4653e8aa5aa50efa5a98.svg";